/**
 * @file    cellFormatting
 * @scope   SHARED
 * @summary Pure cell helpers shared by both tables (value extraction, decimals, survey link).
 * @consumes helpers/utilities
 * @produces getCellValue, isSingleQuestionGridColumn, formatCellValue, openSurveyLink
 * @sideEffects openSurveyLink calls the global CX hook `window.commentSurveyLinkPeacock`.
 */
import { formatValueByDecimalPlaces } from 'helpers/utilities';

/** Returns `cell.value` for object cells, the raw cell otherwise. */
export const getCellValue = (cell: any) =>
  typeof cell === 'object' && cell !== null && 'value' in cell ? cell.value : cell;

/** Single question grids keep punch, response text and frequency without decimals. */
export const isSingleQuestionGridColumn = (col: any) =>
  (col?.field === 'field_2' &&
    col?.colName === 'WeightedResponseCount' &&
    col?.displayName === 'Frequency') ||
  (col?.field === 'field_1' &&
    col?.colName === 'ResponseText' &&
    col?.displayName === 'Response Text' &&
    col?.isNumeric === false) ||
  (col?.field === 'field_0' && col?.colName === 'Punch' && col?.displayName === 'Punch');

export const formatCellValue = (value: any, skipDecimals: boolean, decimalPlaces: any) =>
  skipDecimals ? value : formatValueByDecimalPlaces(value, Number(decimalPlaces));

/** Name of the previous `field_N` column, used by the period-delta comparison. */
export const getPreviousField = (field: string) => `field_${parseInt(field.split('_')[1], 10) - 1}`;

/** Opens a survey through the CX host. Logs instead of throwing outside CX. */
export const openSurveyLink = (row: any, idSurveyPanel: any) => {
  try {
    const surveyParams = { idSurveyPanel, idSurvey: row['field_0'] };
    (window as any)['commentSurveyLinkPeacock'](surveyParams);
  } catch (error: any) {
    console.error(`${error.message}, be sure you are running from CX application`);
  }
};
